module.exports = __webpack_public_path__ + "static/media/ids.8418d4eb.png";